"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayMap = void 0;
const Util_1 = require("../Util");
class ReplayMap {
    constructor(mapFilePath) {
        this.name = (0, Util_1.basename)(mapFilePath, '.bsp');
        this.chunks = [];
        this.resources = {
            sounds: [],
            skins: [],
            models: [],
            decals: [],
            custom: [],
            events: []
        };
    }
    setResources(resources) {
        resources.forEach(res => {
            switch (res.type) {
                case 0: {
                    res.used = false;
                    this.resources.sounds.push(res);
                    break;
                }
                case 1: {
                    this.resources.skins.push(res);
                    break;
                }
                case 2: {
                    this.resources.models.push(res);
                    break;
                }
                case 3: {
                    this.resources.decals.push(res);
                    break;
                }
                case 4: {
                    this.resources.custom.push(res);
                    break;
                }
                case 5: {
                    this.resources.events.push(res);
                    break;
                }
            }
        });
    }
    addChunk(chunk) {
        this.chunks.push(chunk);
    }
}
exports.ReplayMap = ReplayMap;
